import axios from 'axios';

export default axios.create({
  baseURL:"https://mishtystore.ondemandcrm.co", //window.location.origin, //"https://murdartbyhari.ondemandcrm.co", //window.location.origin, //"https://filly.ondemandcrm.co",  //"https://ecommerce.ondemandcrm.co", //window.location.origin,
  headers: {
    'Content-type': 'application/json',
  },
});
